module.exports = __webpack_public_path__ + "assets/touxiang2.3895b7de6ca3119e1f791378c5b5830e.png";